import { TableField } from "../../table-field";

const signatario: TableField = {
  key: "LabelSignatario",
  label: "Categoria",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const statusCol: TableField = {
  key: "Status",
  label: "Status",
  tdClass: ["align-middle", "text-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const responsavel: TableField = {
  key: "UsuarioResponsavel",
  label: "Responsável",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

const nomeSignatario: TableField = {
  key: "NomeSignatario",
  label: "Signatário",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

const dtAssinatura: TableField = {
  key: "DataAssinatura",
  label: "Data de Assinatura",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: false,
};
const acoes: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const fieldsAssinaturaPCM: TableField[] = [
  signatario,
  statusCol,
  responsavel,
  nomeSignatario,
  dtAssinatura,
  acoes,
];
